<template>
  <div>
    <nav class="nav_mobile_top topPadding">
      <div class="nav_content">
        <div class="nav_left">
          <div class="left_logo">
            <div class="back" v-if="isShowBack" @click="$emit('back')">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M15.4 4.6 8.8 12l6.6 7.4-1.5 1.4L5.8 12l8.1-9z" />
              </svg>
            </div>
            <div class="logo" @click="goHome">
              <BrandLogo :mark-only="true" />
              <span class="nav-title">{{ title }}</span>
            </div>
          </div>
          <!-- <div class="nav_name" @click="$emit('show-drawer')">
            {{ title }}
            <img
              src="@/assets/img/icon_arrow.dc4b9070.svg"
              alt=""
              class="arrow-icon"
			  v-if="currentCode"
            />
          </div> -->
        </div>
        <div class="nav_right" v-if="showRight">
          <!-- <div class="action" @click="isLanguage = true" style="width: auto; border-radius: 5px; padding: 0 5px">
            {{ $t("navTab.language") }}
          </div>
          <div class="action sign" v-if="isLogin" @click="$router.push('/profile/notification')">
            <img src="@/assets/img/icon_bell.28bcd54a.svg" alt="" />
          </div>
          <div class="action sign" @click="openService">
            <img src="@/assets/img/service-m.svg" :alt="$t('navBottom.bottomCompanyItem4')" />
          </div> -->
          <div class="action sign" v-if="showSearch" @click="openSearch">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="m17.874 16.46 4.283 4.283-1.414 1.414-4.283-4.283a8.96 8.96 0 0 1-5.617 1.97c-4.968 0-9-4.033-9-9 0-4.969 4.032-9 9-9s9 4.031 9 9a8.96 8.96 0 0 1-1.969 5.616m-2.006-.742a6.98 6.98 0 0 0 1.975-4.875c0-3.867-3.132-7-7-7s-7 3.133-7 7 3.133 7 7 7a6.98 6.98 0 0 0 4.875-1.975z"
              />
            </svg>
          </div>
          <div class="action sign cs-entry" v-if="showService" @click="openService">
            <svg viewBox="0 0 22 21" aria-hidden="true">
              <path
                fill="currentColor"
                d="M10.8333 2.16667C6.04686 2.16667 2.16667 6.04686 2.16667 10.8333H5.41667C6.61328 10.8333 7.58333 11.8034 7.58333 13V18.4167C7.58333 19.6133 6.61328 20.5833 5.41667 20.5833H2.16667C0.970049 20.5833 0 19.6133 0 18.4167V10.8333C0 4.85025 4.85025 0 10.8333 0C16.8164 0 21.6667 4.85025 21.6667 10.8333V18.4167C21.6667 19.6133 20.6967 20.5833 19.5 20.5833H16.25C15.0534 20.5833 14.0833 19.6133 14.0833 18.4167V13C14.0833 11.8034 15.0534 10.8333 16.25 10.8333H19.5C19.5 6.04686 15.6198 2.16667 10.8333 2.16667ZM2.16667 13V18.4167H5.41667V13H2.16667ZM16.25 13V18.4167H19.5V13H16.25Z"
              />
            </svg>
          </div>
          <div class="action sign notice-container" v-if="showNotice && isLogin" @click="$router.push('/profile/notification')">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22m8-6V11a8 8 0 0 0-6.5-7.85V2.5a1.5 1.5 0 1 0-3 0v.65A8 8 0 0 0 4 11v5l-2 2v1h20v-1z"
              />
            </svg>
            <div class="notice-red-dot" v-if="hasNotice"></div>
          </div>
          <div class="action sign" v-if="showCollect" @click="$emit('toggle-collect')">
            <img :src="collected ? collectActiveIcon : collectIcon" :alt="$t('Market.watchlist')" />
          </div>
          <div class="action btn sign" @click="$router.push(authEntryPath)" v-if="!isLogin">
            {{ $t("login.btnLogin") }}
          </div>
          <div v-if="showUserName && isLogin" class="user_name">{{ getUserInfo && getUserInfo.id ? getUserInfo.id : '' }}</div>
        </div>
      </div>

      <div class="search-main" v-show="searchShow" @click="searchShow = false">
        <div class="content" id="content" @click.stop>
          <div class="search-input">
            <img src="@/assets/img/icon_search.9fcf95f5.svg" alt="">
            <input
              type="text"
              v-model="searchQuery"
              :placeholder="$t('souSuo')"
            />
          </div>
          <div class="hr"></div>
          <div class="search-reault" :class="{ 'search-reault--list': filteredMarketList.length > 0 }">
            <div v-if="filteredMarketList.length">
              <div
                class="result-list"
                v-for="item in filteredMarketList"
                :key="item.id"
                @click="goToMarket(item)"
              >
                <div class="list-title">
                  <img v-if="item.logo" :src="item.logo" alt="" />
                  {{ item.appName || item.name || item.code }}
                </div>
                <div class="list-number">{{ item.nowPrice }}</div>
                <div class="list-cent" :class="{ 'list-cent1': Number(item.zdf) < 0 }">{{ item.zdf }}%</div>
              </div>
            </div>
            <div v-else-if="searchQuery.trim()">{{ $t('toast.nothingfound') }}</div>
          </div>
        </div>
      </div>
    </nav>

    <Languages :isPc="isPc" :isLanguage="isLanguage" @close="isLanguage = false" />
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import Languages from "@/components/Languages.vue";
import BrandLogo from "@/components/BrandLogo.vue";
import { openCustomerService } from '@/utils/customerService';
import { listMarketByType } from "@/api/market.js";
import { getAuthEntryPath } from '@/utils/authRedirect';
import collectIcon from "@/assets/img/icon_collect.svg";
import collectActiveIcon from "@/assets/img/icon_collect1.svg";

export default {
  name: "HomeView",
  data() {
    return {
      isLanguage: false,
      showDrawer: false,
      searchQuery: "",
      marketList: [],
      currentCode: "",
      searchShow: false,
      marketListLoading: false,
      collectIcon,
      collectActiveIcon,
    };
  },
  props: {
    title: {
      type: String,
      default: "IC Markets",
    },
    showRight: {
      type: Boolean,
      default: true,
    },
    showNotice: {
      type: Boolean,
      default: true,
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    showUserName: {
      type: Boolean,
      default: true,
    },
    isShowBack: {
      type: Boolean,
      default: false,
    },
    hasNotice: {
      type: Boolean,
      default: false,
    },
    showCollect: {
      type: Boolean,
      default: false,
    },
    collected: {
      type: Boolean,
      default: false,
    },
    showService: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState(["isLogin", "isPc"]),
    ...mapGetters(["getUserInfo", "getMarkTypeList"]),
    getTitle() {
      return this.$route.meta.title;
    },
    filteredMarketList() {
      const query = (this.searchQuery || "").trim().toLowerCase();
      if (!query) {
        return [];
      }
      return this.marketList.filter((item) => this.matchMarketItem(item, query));
    },
    authEntryPath() {
      return getAuthEntryPath();
    },
  },
  components: {
    Languages,
    BrandLogo,
  },
  mounted() {
    this.currentCode = this.$route.query.code || "";
  },
  methods: {
    goHome() {
      if (this.$route.path === '/') {
        return;
      }
      this.$router.push('/');
    },
    matchMarketItem(item, query) {
      const fields = [item.appName, item.name, item.code];
      return fields.some((field) => {
        if (field == null || field === "") return false;
        return String(field).toLowerCase().includes(query);
      });
    },
    async loadAllMarkets() {
      if (this.marketListLoading || this.marketList.length > 0) {
        return;
      }
      this.marketListLoading = true;
      try {
        const types = (this.getMarkTypeList || []).map((t) => t.value);
        const responses = await Promise.all(
          types.map((type) => listMarketByType({ type }))
        );
        const map = new Map();
        responses.forEach((res) => {
          (res.result || []).forEach((item) => {
            if (!map.has(item.id)) {
              map.set(item.id, {
                ...item,
                nowPrice: item.price,
                zdf: item.zdf != null ? (item.zdf * 100).toFixed(2) : "0.00",
              });
            }
          });
        });
        this.marketList = Array.from(map.values());
      } catch (e) {
        console.error("加载市场产品失败:", e);
        this.marketList = [];
      } finally {
        this.marketListLoading = false;
      }
    },
    openSearch() {
      this.searchShow = !this.searchShow;
      if (this.searchShow) {
        this.loadAllMarkets();
      } else {
        this.searchQuery = "";
      }
    },
    goToMarket(item) {
      this.searchShow = false;
      this.searchQuery = "";
      this.$router.push({
        name: "cruuency",
        query: {
          code: item.code,
          type: item.type,
          id: item.id,
        },
      }).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          console.error(err);
        }
      });
    },
    openService() {
      openCustomerService(this);
    },
    selectCurrency(item) {
      if (item.code === this.$route.query.code) {
        return;
      }
      this.$router.replace({
        path: "/cruuency",
        query: {
          code: item.code,
          type: item.type,
          id: item.id,
        },
      });
      this.showDrawer = false;
      this.currentCode = item.code;
    },
  },
};
</script>
<style lang="scss">
.user_name {
  font-size: .16rem;
  color: #454545;
  width: .91rem;
  border-radius: .4rem;
  border: .02rem solid #000;
  box-sizing: border-box;
  height: .36rem;
  margin-left: .1rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav_mobile_top {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  color: #000;
  padding: calc(0.12rem + env(safe-area-inset-top, 0px)) 0 0.12rem;
  z-index: 20;
}

.nav_mobile_top.topPadding {
  padding: calc(0.12rem + env(safe-area-inset-top, 0px)) 0 0.12rem;
}

.nav_mobile_top .nav_content {
  padding: 0 0.24rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* 增强不同设备的兼容性 */
  min-height: 0.36rem;
  box-sizing: border-box;
}

.nav_mobile_top .nav_content .nav_left {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: space-between;
  /* 确保在所有设备上正确对齐 */
  min-height: 0.36rem;

  .left_logo {
    display: flex;
    align-items: center;
    /* 增强垂直对齐 */
    height: 0.36rem;
    line-height: 1;
  }
}

.nav_mobile_top .nav_content .nav_left .back {
  margin-right: 0.1rem;
  width: 0.36rem;
  height: 0.36rem;
  box-sizing: border-box;
  border-radius: 50%;
  border: 0.02rem solid #000;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav_mobile_top .nav_content .nav_left .back svg {
  width: 0.16rem;
  height: 0.16rem;
}

.nav_mobile_top .nav_content .nav_left .logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  line-height: 1;
  margin-right: 0.08rem;
  height: 0.36rem;
  color: #000;

  .bb-brand-mark {
    width: 0.22rem;
    height: 0.26rem;
    margin-right: 0.08rem;
    flex-shrink: 0;
    color: #000;
  }

  .nav-title {
    color: #000;
    font-size: 0.22rem;
    font-weight: 800;
    letter-spacing: normal;
    line-height: 1.2;
    display: flex;
    align-items: center;
    white-space: nowrap;
  }
}

.nav_mobile_top .nav_content .nav_left .nav_name {
  /* padding-bottom: 0.04rem; */
  font-weight: 700;
  font-size: 0.22rem;
  color: #000;
  display: flex;
  align-items: center;
  cursor: pointer;

  .arrow-icon {
    width: 0.16rem;
    height: 0.16rem;
    margin-left: 0.08rem;
  }
}

.nav_mobile_top .nav_content .nav_right {
  display: flex;
}

.nav_mobile_top .nav_content .nav_right .action {
  margin-left: 0.12rem;
  width: 0.36rem;
  height: 0.36rem;
  border: 0.015rem solid #000;
  box-sizing: border-box;
  border-radius: 50%;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav_mobile_top .nav_content .nav_right .action svg {
  width: 0.18rem;
  height: 0.18rem;
  display: block;
}

.nav_mobile_top .nav_content .nav_right .action.btn {
  width: auto;
  border: none;
  font-weight: 700;
  font-size: 0.16rem;
  color: #000;
}

.nav_mobile_top .nav_content .nav_right .action.sign {
  position: relative;
  margin-left: 0.1rem;
}

.nav_mobile_top .nav_content .nav_right .action.sign img {
  width: 0.18rem;
  height: 0.18rem;
  display: block;
  object-fit: contain;
}

.nav_mobile_top .nav_content .nav_right .action.sign .dot {
  position: absolute;
  top: -0.02rem;
  right: 0;
  width: 0.1rem;
  height: 0.1rem;
  border-radius: 50%;
  background: #ff5858;
}

.search-main {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 12;
  line-height: 100%;
  overflow-y: auto;
}

.search-main .content {
  background: #fff;
  border-radius: 0.16rem;
  width: 3.8rem;
  min-height: 2.62rem;
  margin: auto;
  margin-top: 0.62rem;
  padding-top: 0.24rem;
  padding-bottom: 0.16rem;
  margin-bottom: 0.9rem;
}

.search-main .content .search-input {
  height: 0.26rem;
  margin: auto;
  margin-bottom: 0.1rem;
  width: 3.5rem;
}

.search-main .content .search-input input {
  width: 3.1rem;
}

.search-main .content .search-input img {
  vertical-align: middle;
}

.search-main .content .hr {
  width: 3.48rem;
  height: 0.01rem;
  border-bottom: 0.01rem solid rgba(0, 0, 0, 0.1);
  margin: auto;
  margin-bottom: 0.14rem;
}

.search-main .content .search-reault {
  width: 3.5rem;
  margin: auto;
  text-align: center;
  min-height: 2rem;
  line-height: 2rem;
  font-weight: 400;
  font-size: 0.2rem;
}

.search-main .content .search-reault.search-reault--list {
  line-height: normal;
  text-align: left;
}

.search-main .content .search-reault .result-list {
  width: 100%;
  height: 0.58rem;
  padding: 0 0.23rem 0 0.16rem;
  line-height: 0.58rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.04rem;
  background: #000;
  border-radius: 0.16rem;
}

.search-main .content .search-reault .result-list .list-title {
  font-weight: 500;
  font-size: 0.12rem;
  color: #fff;
  line-height: 0.58rem;
}

.search-main .content .search-reault .result-list .list-title img {
  margin-right: 0.08rem;
  height: 0.22rem;
  vertical-align: middle;
}

.search-main .content .search-reault .result-list .list-number {
  font-weight: 400;
  font-size: 0.12rem;
  color: hsla(0, 0%, 100%, 0.5);
  line-height: 0.58rem;
}

.search-main .content .search-reault .result-list .list-cent {
  font-weight: 400;
  font-size: 0.12rem;
  color: #9ee970;
  line-height: 0.58rem;
}

.search-main .content .search-reault .result-list .list-cent1 {
  color: #ff2828;
}

.currency-drawer {
  background: #fff;

  ::v-deep .el-drawer__header {
    margin-bottom: 0 !important;
    padding: 20px;
  }

  .search-wrapper {
    padding: 0 20px;

    .market-search {
      width: 100%;

      ::v-deep .el-input__inner {
        border-radius: 4px;
        height: 36px;

        &:focus {
          border-color: #409eff;
        }
      }
    }
  }

  .drawer-content {
    padding: 0 20px;

    .market-list {
      .market-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 0;
        cursor: pointer;
        border-bottom: 1px solid #f5f5f5;

        &:hover {
          background-color: #f5f7fa;
        }

        &.active {
          background-color: #f5f7fa;
        }

        .item-left {
          display: flex;
          align-items: center;

          .currency-icon {
            width: 24px;
            height: 24px;
            margin-right: 8px;
          }

          .currency-name {
            font-size: 14px;
            color: #333;
          }
        }

        .item-right {
          text-align: right;

          .currency-price {
            display: block;
            font-size: 14px;
            color: #333;
            margin-bottom: 4px;
          }

          .currency-change {
            font-size: 12px;

            &.up {
              color: #67c23a;
            }

            &.down {
              color: #f56c6c;
            }
          }
        }
      }
    }
  }
}

/* 通知红点样式 */
.notice-container {
  position: relative;
}

.notice-red-dot {
  position: absolute;
  top: 0.02rem;
  right: 0.02rem;
  width: 0.08rem;
  height: 0.08rem;
  background: #ff4343;
  border-radius: 50%;
  z-index: 1;
}
</style>
